import React, { memo } from 'react';
import upperFirst from 'lodash/upperFirst';

import { getAppointmentsSortedByDay } from '@front/common/src/utils/appointment';
import { Appointment } from '@front/common/src/types/commons';
import { formatDate, FORMATS } from '@front/common/src/utils/date';

import Text from '@front/web-ui/src/components/base-text/variants/text';

import { DaysList, Day, Slots } from '../../common';
import Slot from '../../slot';

type SingleCleaningAppointmentDetailsProps = {
  appointment: Appointment;
};

const SingleCleaningAppointmentDetails = ({
  appointment: { primary, secondary },
}: SingleCleaningAppointmentDetailsProps) => (
  <DaysList>
    {getAppointmentsSortedByDay(primary, secondary).map(({ day, slots }) => (
      <Day key={day.toISOString()}>
        <Text.MDBold>{day ? upperFirst(formatDate(day, FORMATS.DATE.WEEKDAY_DAY_MONTH)) : ''}</Text.MDBold>
        <Slots>
          {slots.map(({ text, isPrimary, label }) => (
            <Slot key={label} text={text} isPrimary={isPrimary} label={label} />
          ))}
        </Slots>
      </Day>
    ))}
  </DaysList>
);

export default memo(SingleCleaningAppointmentDetails);
